import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import '../styles/Subscription.css';
import kmfLogo from '../assets/obraswise-logo.png';

const Subscription = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="subscription-container">
      <header className="subscription-header">
        <h1>ObrasWise</h1>
        <div className="user-info">
          <span>{currentUser?.nome || currentUser?.email}</span>
          <button onClick={handleLogout} className="logout-button">Sair</button>
        </div>
      </header>
      
      <main className="subscription-content">
        <div className="subscription-card">
          <div className="logo-container" style={{ textAlign: 'center', marginBottom: '20px' }}>
            <img src={kmfLogo} alt="KMF Engenharia" style={{ maxHeight: '80px' }} />
          </div>
          <h2 className="subscription-title">PLANOS E PREÇOS</h2>
          <p className="subscription-subtitle">Escolha a melhor forma de pagamento para você!</p>
          <div className="subscription-plans modern-layout">
            {/* PLANO MENSAL */}
            <div className="plan-card orange modern">
              <h3 className="plan-title">PLANO MENSAL</h3>
              <p className="plan-desc">Acesso por um mês ao Software do ObrasWise</p>
              <p className="plan-update">*Atualizações Inclusas*</p>
              <p className="plan-old-price"><s>De R$ 149,00 por</s></p>
              <p className="plan-price">R$ 59</p>
              <ul className="plan-list">
                <li>1 usuário cadastrado</li>
                <li>Até 3 obras por mês</li>
                <li>Até 5 orçamentos por mês</li>
              </ul>
              <button className="plan-button green">QUERO ESSE PLANO</button>
            </div>
            {/* PLANO MENSAL CORPORATIVO */}
            <div className="plan-card orange modern">
              <h3 className="plan-title">PLANO MENSAL CORPORATIVO</h3>
              <p className="plan-desc">Acesso por um mês ao Software do ObrasWise</p>
              <p className="plan-update">*Atualizações Inclusas*</p>
              <p className="plan-old-price"><s>De R$ 399,00 por</s></p>
              <p className="plan-price">R$ 217</p>
              <ul className="plan-list">
                <li>Até 5 usuários cadastrados</li>
                <li>Obras ilimitadas</li>
                <li>Orçamentos ilimitados</li>
              </ul>
              <button className="plan-button green">QUERO ESSE PLANO</button>
            </div>
            {/* PLANO ANUAL */}
            <div className="plan-card orange modern">
              <h3 className="plan-title">PLANO ANUAL</h3>
              <p className="plan-desc">Acesso por um ano ao Software do ObrasWise</p>
              <p className="plan-update">*Atualizações Inclusas*</p>
              <p className="plan-old-price"><s>De R$ 4738,00 por</s></p>
              <p className="plan-price">R$ 2400</p>
              <ul className="plan-list">
                <li>Até 5 usuários cadastrados</li>
                <li>Obras ilimitadas</li>
                <li>Orçamentos ilimitados</li>
              </ul>
              <button className="plan-button green">QUERO ESSE PLANO</button>
            </div>
          </div>
          <div className="contact-info">
            <p>Precisa de ajuda? Entre em contato:</p>
            <p>Email: <a href="mailto:suporte@obraswise.com.br" style={{ color: '#ffa600', fontWeight: 600 }}>suporte@obraswise.com.br</a></p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Subscription; 